export const SITE_ORIGIN = "https://www.rorostweed.com";

export const DEFAULT_LOCALE = "en";

export const LOCALES = ["en", "no"];

// Legacy shim: both locales resolve to .com after the single-domain migration.
// Consumers that build `https://${DOMAIN_MAP[locale].domain}/...` keep working
// and emit .com URLs. To be deleted once all call sites migrate to SITE_ORIGIN.
export const DOMAIN_MAP = {
  en: {
    domain: "www.rorostweed.com",
    defaultLocale: "en",
  },
  no: {
    domain: "www.rorostweed.com",
    defaultLocale: "no",
  },
};

/** @type {import('next').NextConfig} */
const i18nConfig = {
  i18n: {
    locales: LOCALES,
    defaultLocale: DEFAULT_LOCALE,
    localeDetection: false,
  },
  react: { useSuspense: false }, //this line is important
};

export const DOMAINS = Object.values(DOMAIN_MAP);

export default i18nConfig;
